import { jsx as m } from "react/jsx-runtime";
import { n3wthTheme as o } from "./n3wthTheme.js";
import { Theme as t } from "../packages/ui/node_modules/@astryxdesign/core/dist/theme/Theme.js";
function i({ children: r, mode: e = "dark" }) {
  return /* @__PURE__ */ m(t, { theme: o, mode: e, children: r });
}
i.displayName = "N3wthProvider";
export {
  i as N3wthProvider
};
//# sourceMappingURL=N3wthProvider.js.map
